import { useEffect, useState } from 'react';
import { isEmpty } from 'lodash';
// import { cloneDeep } from 'lodash';
import { useHistory } from 'react-router';
import {
    useButtonsStore,
    useSchedulesStore,
    // useUserStore,
} from '../../../store/models';
import useUndoLogo from '../../../store/models/buttons/useUndoLogo';

import useStoreModuleDependency from '../../hooks/useStoreModuleDependency';
import useButtonWidgetErrors from '../../../store/models/buttons/errors/useButtonWidgetErrors';
// import useModuleError from './useModuleError';
import { useTouchContext } from '../../../app/context/TouchContext';

import { withDefaultBanners } from '../../../utils/defaults';
import defaultInput from './defaultButton.json';
import useScheduleValidation from '../../hooks/useScheduleValidation';

const Mode = {
    ADD: 'add',
    EDIT: 'edit',
};

const DisplayTypes = {
    BUTTON: 'button',
    AD: 'ad',
};

function useModuleInput (props) {
    const {
        location,
    } = props;

    const history = useHistory();
    function getMode () {
        if (location.pathname.indexOf('edit') !== -1) {
            return Mode.EDIT;
        }
        return Mode.ADD;
    }

    function getDisplayType () {
        const path = history.location.pathname;
        if (path.indexOf('/admin/displays/add/ad') !== -1 ||
        path.indexOf('/admin/displays/ad/edit') !== -1) {
            return DisplayTypes.AD;
        }
        return DisplayTypes.BUTTON;
    }

    const [mode] = useState(getMode());
    const [displayType] = useState(getDisplayType());
    const [input, setInput] = useState({
        ...defaultInput,
        name: '',
    });
    const [options, setOptions] = useState({});
    /*
     * savable state is an state that will not be observe by the UI.
     * a replica of input state but will be updated every time the changes happened...
     * Changes on the savable state will not be rendered. for faster performance.
     * will be validated for an error..
     */
    const [savable, setSavableData] = useState({ ...defaultInput });
    const [saveDisabled, setSaveDisabled] = useState(true);
    const [progress, setProgress] = useState({
        save: false,
    });

    const [messageOpen, setMessageOpen] = useState(false);
    const [touched, setTouched] = useState({});
    const [inputErrors, setInputErrors] = useState({
        title: '',
        message: '',
    });
    const {
        errors,
        hasError,
        hasInputError,
    } = useButtonWidgetErrors({
        progress,
        setProgress,
        input: savable,
        mode,
    });

    const {
        pushActiveStates,
    } = useUndoLogo();
    const { validateUpsertRule } = useScheduleValidation(setInputErrors);

    const buttonsStore = useButtonsStore();
    const schedulesStore = useSchedulesStore();
    const { updateTouches } = useTouchContext('useButtonWidgetErrors');
    // const userStore = useUserStore();

    function updateTouch (touchData) {
        setTouched({ ...touched, ...touchData });
    }

    function initStore () {
        setProgress({ ...progress, buttons: true });
        schedulesStore.filterText = '';
        schedulesStore.getRootCategories();
        if (mode === Mode.EDIT) {
            buttonsStore.loadEditData();
            initWithEditData();
        }
    }

    function initWithEditData () {
        const initData = {
            ...buttonsStore.editData,
            type: displayType,
            style: {
                ...buttonsStore.editData.style,
                template: buttonsStore.editData.style.template ? buttonsStore.editData.style.template : 'ecal-round',
            },
        };
        withDefaultBanners(initData);
        setInput(initData);
        setSavableData(initData);
        window.savableData = initData;
    }

    useEffect(() => {
        console.log('useModuleInput.useEffect().input :', input);
    }, [input]);

    useEffect(() => {
        setProgress({ ...progress, save: false });
      if (isEmpty(errors)) {
        if (updateTouches.width) {
            setSaveDisabled(false);
        }
      } else {
        setSaveDisabled(true);
      }
    }, [errors]);

    useEffect(() => {
        setProgress({ ...progress, save: false });
    }, [hasError]);

    useStoreModuleDependency({ initStore });

    useEffect(() => {
        window.savableData = { ...savable };
    }, [savable]);

    useEffect(() => {
        buttonsStore.assets = {}; // ensure that assets url is empty on launch..
    }, []);

    function toggleSaveForAdWidget (data) {
        if ((!data.name && data.name.length <= 0) || !data.image) {
            setSaveDisabled(true);
            return;
        }

        // Check schedule validation for save button state only
        const isValidSchedule = validateUpsertRule(data, false);
        setSaveDisabled(!isValidSchedule);
    }

    function taggleSaveForButtonWidget (data) {
        if (!data.name || data.name.length <= 0) {
            setSaveDisabled(true);
            return;
        }

        // Check schedule validation for save button state only
        const isValidSchedule = validateUpsertRule(data, false);
        setSaveDisabled(!isValidSchedule);
    }

    function updateSavable (data) {
        clearTimeout(window.updateSavable);
        function delay () {
            setSavableData(data);
            window.savableData = data;
            if (!buttonsStore.shouldSkipStackPush()) {
                buttonsStore.stylesData = data.style;
                pushActiveStates();
            }
            if (displayType === DisplayTypes.AD) {
                toggleSaveForAdWidget(data);
                return;
            }
            taggleSaveForButtonWidget(data);
        }
        window.updateSavable = setTimeout(delay, 400); // debounce update till user input stopped in 400ms
    }

    /*
     * This will just copy the updated state to input to reflect the changes on the UIs
     * only being called during the unmounting
     */
    function copySavableToInput () {
        // instead of waiting for PopupDesign UI to Mount and retrieving the dataSource.style from the mount
        // we copy the style data directly on transfering savable state.style to buttonStore.stylesData
        // this prevents the lost of theme property without affecting the style states
        buttonsStore.stylesData = window.savableData.style ? { ...window.savableData.style } : { ...savable.style };
        buttonsStore.initBannerState(buttonsStore.stylesData);
        if (isEmpty(buttonsStore.stylesData.theme) && displayType === DisplayTypes.BUTTON) {
            // Fallback when user didn't touched anything in Button Design settings.
            buttonsStore.stylesData.theme = 'purple';
        }
        setInput({ ...window.savableData });
    }

    function upsertButtons () {
        const widget = {
            ...savable,
            type: displayType,
            draft: undefined,
        };

        if (mode === Mode.ADD) {
            buttonsStore.addWidget(widget, options);
        } else if (mode === Mode.EDIT) {
            buttonsStore.editWidget(widget, options);
        }
    }

    function upsert () {
        setProgress({ ...progress, save: true });
        /* Enter update/edit mechanism here */
        upsertButtons();
    }

    function updateOptions (newOpts) {
        setOptions({
            ...options,
            ...newOpts,
        });
    }

    return {
        input,
        mode,

        upsert, // call add or edit

        progress,
        setProgress,

        hasError,
        errors,
        hasInputError,

        messageOpen,
        setMessageOpen,
        saveDisabled,
        setSaveDisabled,
        updateSavable,
        copySavableToInput,
        updateOptions,
        loadCategories: initStore,
        touched,
        updateTouch,
        inputErrors,
        setInputErrors,
    };
}

export default useModuleInput;
